import React from 'react';

const SettingsPage: React.FC = () => {
  return (
    <div className="text-center py-16 px-8 bg-white rounded-xl border border-gray-200">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">Configurações</h1>
      <p className="text-lg text-gray-600">Em desenvolvimento...</p>
    </div>
  );
};

export default SettingsPage;
